import i18next from 'i18next';
import { PlanTypeCategory } from '../../enum';
import { useDownload } from '../hooks';
var DOWNLOAD_TEMPLATE_API = '/api/report/template/export';
export var useDownloadTemplateAPI = function (planTypeCategory, shouldDownload) {
    if (shouldDownload === void 0) { shouldDownload = true; }
    var fileName = planTypeCategory === PlanTypeCategory.ProdHours
        ? i18next.t('translation:prodHoursTemplate')
        : i18next.t('translation:workVolumeTemplate');
    return useDownload(DOWNLOAD_TEMPLATE_API, "".concat(fileName, ".xlsx"), { method: 'POST', shouldDownload: shouldDownload });
};
